import { ApiUtil as api } from '@/utils/api.util.js'

export class RoleService {
    static URL = process.env.API_URL + process.env.API_VER
    static RESOURCE = '/roles/'
    static all(queryParams = {}) {
        return api.get(this.URL + this.RESOURCE, queryParams)
    }
    static create(queryParams = {}) {
        return api.post(this.URL + this.RESOURCE, queryParams)
    }
    static syncPermissions(id, queryParams = {}) {
        return api.put(this.URL + this.RESOURCE + id + '/permissions', queryParams)
    } 
    static getPermissions(queryParams = {}) {
        return api.get(this.URL + this.RESOURCE + 'all/permissions', queryParams)
    }
    static toggleTag(queryParams = {}) {
        return api.post(this.URL + this.RESOURCE + 'toggle/tag', queryParams)
    }
    static getTags(queryParams = {}) {
        return api.get(this.URL + this.RESOURCE + 'get/tags', queryParams)
    }
    static find(id, queryParams = {}) {
        return api.get(this.URL + this.RESOURCE + id, queryParams)
    }

    static attachPermissions(id, data = {}) {
        return api.put(this.URL + this.RESOURCE + id + '/attach-permissions', data);
    }

    static detachPermissions(id, data = {}) {
        return api.put(this.URL + this.RESOURCE + id + '/detach-permissions', data);
    }
}




// WEBPACK FOOTER //
// ./src/services/role.service.js